import { useState, useEffect } from 'react';

import { useMainMachine } from '../../../utils/useMainMachine';
import { STATES } from '../../../state';
import { Controls } from './Controls';
import { BrandCheckResult } from './BrandCheckResult';

export function ElementEditor() {
  const { useSelector } = useMainMachine();

  const selectedElement = useSelector(({ context }) => context.selectedElement);
  const failedElSelected = selectedElement?.failedElSelected;
  const visible = useSelector(
    (state) =>
      state.matches({ [STATES.INITIALIZED]: { [STATES.EDITOR]: STATES.EDIT } }) ||
      state.matches({ [STATES.INITIALIZED]: { [STATES.EDITOR]: STATES.AI_SUGGESTIONS } }),
  );

  const [showContentType, setShowContentType] = useState(failedElSelected ? 'text' : null);
  useEffect(() => {
    setShowContentType(failedElSelected ? 'text' : null);
  }, [selectedElement?.selector, failedElSelected]);

  if (!visible || !selectedElement) return null;

  const needsContentTypeSelection =
    !showContentType &&
    (selectedElement.hasImmediateChildTextNode || selectedElement.editableChildNodes.length > 0) &&
    selectedElement.hasBgImage;

  const showImage =
    (selectedElement.isEditable && selectedElement.isImage) ||
    (selectedElement.hasBgImage && !needsContentTypeSelection && showContentType !== 'text');
  const showContent = (selectedElement.isEditable || showImage) && !needsContentTypeSelection;

  return (
    <>
      <Controls showContent={showContent} showImage={showImage} setShowContentType={setShowContentType} />
      <BrandCheckResult contentVisible={showContent && !showImage} />
    </>
  );
}
